import {getApiMetadata} from '../../helpers/api-metadata'
import {fetchJSONWith} from '../../platform/functional-fetch-wrapper'
import type {Recap, RecapsRequest, RecapsResponse} from './types'

export async function apiGetRecaps(params: RecapsRequest): Promise<Array<Recap>> {
  const apiData = getApiMetadata('scribe-recaps-api-data')
  const url = new URL(apiData.url, window.location.origin)
  url.searchParams.set('project_number', params.projectNumber.toString())
  url.searchParams.set('owner_type', params.ownerType)
  url.searchParams.set('owner_id', params.ownerIdentifier)

  const {data} = await fetchJSONWith<RecapsResponse>(url.toString(), {
    method: 'GET',
  })

  return data.payload?.scribeRecapsRoute?.recaps ?? []
}
